/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBeer = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="m16.568 2 .233.008c1.931.114 3.682 1.335 4.605 3.13.546 1.061.644 1.87.603 3.367L22 8.947V22H6v-4H2V8h4.129a3.993 3.993 0 0 1-.037-1.856A4.012 4.012 0 0 1 9.247 3.07a3.993 3.993 0 0 1 3.158.74l.023.018.026-.028a5.453 5.453 0 0 1 3.875-1.798zM15 16a3 3 0 0 1-3-3v-3H8v10h12V10h-2v3a3 3 0 0 1-2.824 2.995zm-9-6H4v6h2zm10.543-6.001-.206.005a3.487 3.487 0 0 0-2.917 1.875 1 1 0 0 1-1.73.065l-.093-.135a1.99 1.99 0 0 0-1.985-.773 2.013 2.013 0 0 0-1.564 1.527 1.96 1.96 0 0 0 .176 1.343L8.278 8H14v5a1 1 0 0 0 1 1l.117-.007A1 1 0 0 0 16 13V8h4.017l-.002-.274c-.016-.647-.1-1.066-.317-1.53l-.07-.144C18.994 4.821 17.795 4.016 16.543 4z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgBeer as Beer };
